import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_PROMOTE_OR_SHARE_WHATSAPP_CTA = defineFcm('psf_promote_or_share_whatsapp_cta')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Channel-aware CTA (WhatsApp rerun, CHANGE-98145): kill-switch + experiment binding for the "Share to WhatsApp" primary button shown on the promote_or_share share slide-up to WhatsApp-arrival signers. Facebook ships productized via psf_promote_or_share_channel_aware_cta and is unaffected by this config.',
		import: false,
		template: {
			enabled: false,
			experimentName: 'psf_promote_or_share_whatsapp_cta_experiment',
		},
	});
